var PageViewPerformanceValidator = /** @class */ (function () {
    function PageViewPerformanceValidator() {
    }
    PageViewPerformanceValidator.prototype.Validate = function (item) {
        /* TODO re-enable once design of iTelemetryItem is finalized. Task used to track this:
         https://mseng.visualstudio.com/AppInsights/_workitems/edit/1310871
        
        // verify system properties has a ver field
        if (!item.sytemProperties ||
            !item.sytemProperties["ver"]) {
            return false;
        }

        if (!item.domainProperties ||
            !item.domainProperties["domProcessing"] ||
            !item.domainProperties["duration"] ||
            !item.domainProperties["name"] ||
            !item.domainProperties["networkConnect"] ||
            !item.domainProperties["perfTotal"] ||
            !item.domainProperties["receivedResponse"] ||
            !item.domainProperties["sentRequest"] ||
            !item.domainProperties["url"]) {
            return false;
        }
        */
        return true;
    };
    PageViewPerformanceValidator.PageViewPerformanceValidator = new PageViewPerformanceValidator();
    return PageViewPerformanceValidator;
}());
export { PageViewPerformanceValidator };
//# sourceMappingURL=PageViewPerformanceValidator.js.map